export class MapTitleStyle {
  size = '';
  color = '';
  font = 'tb-font-primary';

  static normalize(listStyles: Partial<MapTitleStyle>): MapTitleStyle {
    const pureListStyle = new MapTitleStyle();

    pureListStyle.size = listStyles.size ?? pureListStyle.size;
    pureListStyle.color = listStyles.color ?? pureListStyle.color;
    pureListStyle.font = listStyles.font ?? pureListStyle.font;

    return pureListStyle;
  }
}
